module.exports = __webpack_public_path__ + "static/media/icon.pinterest.71e2244a.svg";